
<template>
    <div>
        <modal 
        name="createBenRequestModal" 
        classes="v-modal-sec invite-emp-modal"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="700px"
        height="auto">
        <div class="v-modal">
            <div class="popup-header fromDetailsPage">
               <div class="header-left">
                <h2 class="popup-title">{{ editMode ? 'Update Employee Information' : !isCallFromAddEmployee ? 'Invite Employee':'Add Employee'}}</h2>
                  <div v-if="editMode" class="flex flex-col ml-4 items-start emp-detail-status">
                    <vs-chip v-if="[51].indexOf(getUserRoleId) <= -1" class=""
                      :color="getEmployeeStatusColor(checkProperty(newBeneficiaryDetails, 'statusDetails', 'id'))">
                      {{ checkProperty(newBeneficiaryDetails, 'statusDetails', 'name') }}
                    </vs-chip>
                    <span v-if="getActivationSubtext(newBeneficiaryDetails)" class="text-xs text-gray-600 nowrap flex items-start">
                        {{ getActivationSubtext(newBeneficiaryDetails) }}
                        <span class="ml-2 cursor-pointer underline" v-if="checkProperty(newBeneficiaryDetails, 'terminatedOn') && [1].indexOf(getUserRoleId) <= -1" @click = "onChangeTerminate()">Change</span>
                    </span>
                  </div>
                  </div>
                  <!-- <span class="statusspan text-white nowrap"
                    :class="{
                      status_pending:
                        checkProperty(newBeneficiaryDetails, 'statusDetails', 'id') == 1,
                      status_active:
                        checkProperty(newBeneficiaryDetails, 'statusDetails', 'id') == 2,
                      status_onHold:
                        checkProperty(newBeneficiaryDetails, 'statusDetails', 'id') == 3,
                      status_rejected:
                        [4, 5].indexOf(checkProperty(newBeneficiaryDetails, 'statusDetails', 'id')) >-1,
                    }"
                    >{{ checkProperty(newBeneficiaryDetails, 'statusDetails', 'name') }}
                  </span> -->
                  <!-- <small class="text-white text-xs mt-1 flex align-items-center">
                    <template v-if="[1].indexOf(checkProperty(newBeneficiaryDetails, 'statusDetails', 'id')) >-1">
                      Becomes Active on {{ checkProperty(newBeneficiaryDetails, 'hiredOn') | formatDate }}.
                    </template>
                    <template v-if="checkProperty(newBeneficiaryDetails, 'terminatedOn')">
                      Terminates on {{ checkProperty(newBeneficiaryDetails, 'terminatedOn') | formatDate }}.
                      <p class="ml-2 cursor-pointer underline" v-if="checkProperty(newBeneficiaryDetails, 'statusDetails', 'id') == 5" @click = "onChangeTerminate()">Change</p>
                    </template>
                  </small> -->
                <span @click="$modal.hide('createBenRequestModal');closeAddBenPopUp()">
                <em class="material-icons">close</em>
                </span>
            </div>
            <form  @submit.prevent data-vv-scope="beneficiaryform">
          <div class="form-container ">
            <div class="vx-row">
                      <div class="vx-col w-full"  @keyup="formerrors.msg=''" @click="formerrors.msg=''">
                      <!-- <div class="vx-col w-full"> -->
                        <!-- <vx-input-group class="form-input-group delete-rows-cst FML"> -->
                          <vx-input-group class="form-input-group FML">
                            <immiInput :wrapclass="'md:w-1/3'" formscope="beneficiaryform" :cid="'benf'" v-model="newBeneficiaryDetails.firstName"  :display="false" :tplkey="'firstName'" :tplsection="''"   :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" :disabled="editMode && [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" />
                            <immiInput :wrapclass="'md:w-1/3'" formscope="beneficiaryform" :cid="'benm'" v-model="newBeneficiaryDetails.middleName" :display="false" :tplkey="'middleName'" :tplsection="''"   :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" :disabled="editMode && [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"/>
                            <immiInput :wrapclass="'md:w-1/3'" formscope="beneficiaryform" :cid="'benm'" v-model="newBeneficiaryDetails.lastName" :display="false" :tplkey="'lastName'" :tplsection="''"   :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" :disabled="editMode && [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" />
                          </vx-input-group>
                        <!-- </vx-input-group>                            -->
                        </div>
                            <div v-if="editMode" class="vx-col md:w-1/2 relative">
                              <immiInput :wrapclass="'md:w-full'"  :display="false"  v-model="newBeneficiaryDetails.email"  :tplkey="'email'" :datatype="'required|strict_email'" cid="benfemail" formscope="beneficiaryform"  :required="true" :tplsection="''"  :fieldName="'email'"  label="Email" placeHolder="Email" :disabled="editMode"/>
                              <img v-if="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) <= -1" @click="changeEmail" src="@/assets/images/icons/edit_icon_1.svg" class="email_edit"/>
                            </div>
                            <!-- <span v-if="editMode"><immiInput :wrapclass="'md:w-3/8'"  :display="false"  v-model="newBeneficiaryDetails.email"  :tplkey="'email'" :datatype="'required|strict_email'" cid="benfemail" formscope="beneficiaryform"  :required="true" :tplsection="''"  :fieldName="'email'"  label="Email" placeHolder="Email" :disabled="editMode"/>
                                <span>
                                  <button radius color="warning" type="filled" icon-pack="IntakePortal" class="'md:w-1/8'">
                                    <img @click="changeEmail" src="@/assets/images/icons/edit_icon_1.svg" />                   
                                  </button>
                                </span>
                            </span> -->
                            <immiInput v-if="!editMode" :wrapclass="'md:w-1/2'"  :display="false"  v-model="newBeneficiaryDetails.email"  :tplkey="'email'" :datatype="'required|strict_email'" cid="benfemail" formscope="beneficiaryform"  :required="true" :tplsection="''"  :fieldName="'email'"  label="Email" placeHolder="Email" :disabled="editMode"/>
                            <div v-if="editMode" class="vx-col md:w-1/2 w-full">
                              <!-- <DatepickerField  wrapclass="md:w-full"
                                v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                                label="Hired Date" :validationRequired="false" :dateEnableTo="new Date()" /> -->
                                <!-- <DatepickerField  wrapclass="md:w-full"
                                v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                                label="Hired Date" :validationRequired="false" /> -->
                                <DatepickerField  wrapclass="md:w-full"
                                v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                                label="Hire Date" :validationRequired="false" :isDisabled="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" />
                                <span class="text-danger text-sm" v-show="showHireDateValidationError">Hire date must be before termination date</span>
                            </div>
                            <!-- <DatepickerField v-if="!editMode"   v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'" label="Hired Date" :validationRequired="false" :dateEnableFrom="new Date()" /> -->
                              <!-- label="Hired Date" -->
                            <DatepickerField v-if="!editMode"   v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'" label="Hire Date" :validationRequired="false" :enableToolTip="true"/> 
                            <immiPhone v-if="editMode" :wrapclass="'md:w-1/2 phonenumber_sm'"  :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="(data)=>updatePhoneCountryCode(data,'phoneCountryCode')" :countrycode="newBeneficiaryDetails.phoneCountryCode.countryCode" cid="bencellPhoneNumber" formscope="beneficiaryform" v-model="newBeneficiaryDetails.phone" :tplsection="''"  :fieldName="'cellPhoneNumber'" :required="[50].indexOf(getUserRoleId) > -1 ? false :true" label="Phone Number" placeHolder="Phone Number" :disableAddress="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"/>
                            <!-- <immiPhone v-if="editMode" :wrapclass="'md:w-1/2 phonenumber_sm'"  :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="updatePhoneCountryCode" :countrycode="newBeneficiaryDetails.phoneCountryCode.countryCode" cid="benmobilePhoneNumber" formscope="beneficiaryform" v-model="newBeneficiaryDetails.mobileNum" :tplsection="''"  :fieldName="'mobilePhoneNumber'" :required="false" label="Mobile Number" placeHolder="Mobile Number" /> -->
                            <immiPhone v-if="editMode" :wrapclass="'md:w-1/2 phonenumber_sm'"  :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="(data)=>updatePhoneCountryCode(data,'homePhoneCountryCode')" :countrycode="checkProperty(newBeneficiaryDetails, 'homePhoneCountryCode', 'countryCode')" cid="benmobilePhoneNumber" formscope="beneficiaryform" v-model="newBeneficiaryDetails.homePhone" :tplsection="''"  :fieldName="'mobilePhoneNumber'" :required="false" label="Mobile Number" placeHolder="Mobile Number" :disableAddress="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"/>
                            <div class="vx-col md:w-1/2 w-full mt-4" v-if="!editMode">
                              <div class="flex items-center">
                                <vs-switch v-model="sendInviteNow" :disabled="!newBeneficiaryDetails.email">
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <span class="ml-2">Send account invite now</span>
                              </div>
                          </div>
                    
                    <div class="vx-col w-full" v-if="editMode">
                          <div v-if="countries.length > 0 && !isCallFromAddEmployee">
                              <!-- <h3 class="small-header pt-2"> Address</h3> -->
                              <!-- <addressFields v-if="countries.length > 0"  :prefiilAddress="false"
                                :addFormContainerCls="false" :validationRequired="false"
                              :showaptType="true" :countries="countries" v-model="newBeneficiaryDetails.address" :cid="'add'" 
                              :showAPTCheckBox="false" formscope="beneficiaryform"/> -->
                              <!-- <addressFields :wrapclass="'pad0'"  :prefiilAddress="true" :hideusa="false" :validationRequired="false" :disableCountry="false" :formscope="'beneficiaryform'" :showaptType="true" :addFormContainerCls="true" :countries="countries"  v-model="newBeneficiaryDetails.address" fieldName="chi_addressOutsideUS" :cid="'chi_addressOutsideUS'" /> -->
                          </div>
                      </div>
                      <template  v-if="editMode">
                        <h3 class="small-header pt-2 pl-4 w-full"> Address</h3>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">

                            <!-- <label for class="form_label">Street Address<em>*</em></label> -->
                            <label for class="form_label">Address Line 1<em v-if="[50].indexOf(getUserRoleId) <= -1">*</em></label>
                            <vs-input  formscope="beneficiaryform" :key="'address1'" autocomplete="off" autocorrect="off" name="address1" v-model="newBeneficiaryDetails.address.line1"
                              class="w-full" data-vv-as="Street Address" v-validate="[50].indexOf(getUserRoleId) > -1 ? '':'required'" :disabled="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" />

                            <span class="text-danger text-sm" v-show="errors.has('beneficiaryform.address1')">{{
                              errors.first("beneficiaryform.address1")
                            }}</span>
                          </div>
                        </div>

                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">

                            <!-- <label for class="form_label">Apt</label> -->
                            <label for class="form_label">Address Line 2</label>
                            <vs-input formscope="beneficiaryform" :key="'address2'" name="address2" v-model="newBeneficiaryDetails.address.line2" class="w-full"
                              data-vv-as="Apt" :disabled="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" placeholder="Apt, Suite, Floor, Unit, Building" />
                            
                          </div>
                        </div>

                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <label for class="form_label">Country/Territory<em v-if="[50].indexOf(getUserRoleId) <= -1">*</em></label>
                            <div class="con-select w-full">
                              <multiselect name="addresscountry" v-model="newBeneficiaryDetails.address.countryDetails"
                                @input="changedCountry" :show-labels="false" track-by="id" label="name" v-validate="[50].indexOf(getUserRoleId) > -1 ? '':'required'"
                                data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"  :disabled=" loading || [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"
                                :allow-empty="false" ref="bncountry"  formscope="beneficiaryform" ></multiselect>
                            </div>
                            <span class="text-danger text-sm" v-show="errors.has('beneficiaryform.addresscountry')">{{
                              errors.first("beneficiaryform.addresscountry") }}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <label for class="form_label">State<em v-if="[50].indexOf(getUserRoleId) <= -1 && states.length > 0">*</em></label>
                            <div class="con-select w-full">
                              <multiselect name="State" v-model="newBeneficiaryDetails.address.stateDetails" @input="changedState"
                              v-validate="[50].indexOf(getUserRoleId) > -1 ? '':states.length > 0 ? 'required' :''"
                                :show-labels="false" track-by="id" label="name"
                                data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"  :disabled=" loading || states.length == 0 || [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"
                                :allow-empty="false"  formscope="beneficiaryform" >
                              </multiselect>
                            </div>

                            <span class="text-danger text-sm" v-show="errors.has('beneficiaryform.State')">{{
                              errors.first("beneficiaryform.State")
                            }}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <label for class="vs-select--label">City<em v-if="[50].indexOf(getUserRoleId) <= -1 && locations.length > 0">*</em></label>
                            <div class="con-select w-full">
                              <multiselect name="city" v-model="newBeneficiaryDetails.address.locationDetails" @input="changedCity"
                              v-validate="[50].indexOf(getUserRoleId) > -1 ? '':locations.length > 0 ? 'required':''"
                                :show-labels="false" track-by="id" label="name"
                                data-vv-as="City" placeholder="Select City" :options="locations" :searchable="true" 
                                :disabled=" loading|| newBeneficiaryDetails.address.stateDetails==null || newBeneficiaryDetails.address.countryDetails==null || [4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"
                                :allow-empty="false"  formscope="beneficiaryform" >
                              </multiselect>
                            </div>
                            <span class="text-danger text-sm" v-show="errors.has('beneficiaryform.city')">{{
                              errors.first("beneficiaryform.city")
                            }}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <label for class="form_label">Zip Code<em v-if="[50].indexOf(getUserRoleId) <= -1">*</em></label>
                            <vs-input :key="'zipcode'" name="zipcode" v-model="newBeneficiaryDetails.address.zipcode"
                              v-validate="[50].indexOf(getUserRoleId) > -1 ?'' :'required|allowNumAndCharInZipcode:bncountry|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"
                              @input="checkZipCodeFormat()"  formscope="beneficiaryform" :disabled="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1"
                              />
                            <span class="text-danger text-sm" v-show="errors.has('beneficiaryform.zipcode')">{{
                              errors.first("beneficiaryform.zipcode")
                            }}</span>
                          </div>
                        </div>
                      </template>

         
                        <!-- <div v-if="editMode" class="vx-col md:w-1/2 w-full">
                          <DatepickerField  wrapclass="md:w-full"
                            v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                            label="Hired Date" :validationRequired="false" :dateEnableTo="new Date()" /> -->
                            <!-- <DatepickerField  wrapclass="md:w-full"
                            v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                            label="Hired Date" :validationRequired="false" />
                            <DatepickerField  wrapclass="md:w-full"
                            v-model="newBeneficiaryDetails.hiredOn"  :fieldName="'Hired Date'" :formscope="'beneficiaryform'"
                            label="Hire Date" :validationRequired="false" :isDisabled="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) > -1" />
                            <span class="text-danger text-sm" v-show="showHireDateValidationError">Hire date must be before termination date</span>
                        </div> -->
                             
                      <template v-if="[48,50,12].indexOf(getUserRoleId)<=-1 && !isCallFromAddEmployee"> 
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                              <label class="form_label">Select Employer<em>*</em></label>
                             
                                <multiselect
                                  v-model="selectedPetitioner"
                                  :options="petitionersList"
                                  :multiple="false" 
                                  :hideSelected="false"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :select-label="'Search Employer'"
                                  placeholder="Select Employer"
                                  label="name"
                                  track-by="name"
                                  :preselect-first="false"
                                  name="Employer"
                                   data-vv-as="Employer"
                                   v-validate="'required'"
                                     tag-placeholder="Invite Employer"
                                  
                                  :searchable="true"
                                   @search-change="searchPet" 
                                  :disabled="editMode"
                                  >
                                
                                  <template slot="selection" slot-scope="{ values, isOpen }">
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && !isOpen"
                                    >{{ values.length }} options selected</span
                                    >
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && isOpen"
                                    ></span>
                                  </template>
                                </multiselect>
                              </div>
                              <span class="text-danger text-sm"  v-show="errors.has('beneficiaryform.Employer')">{{ errors.first("beneficiaryform.Employer") }}</span>
                            
                            </div> 
                            <p v-if="callFromList && !editMode" class="createnew pt-3">Not found?<span  @click="addNewPet()">Invite Employer</span> </p> 
                            
                          </div>

                    </template>
                      </div>
          </div>
          <div class="popup-footer relative" v-if="[4].indexOf(checkProperty(newBeneficiaryDetails, 'statusId')) <= -1">
            <figure v-if="submitForm" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            <button color="dark" @click="closeAddBenPopUp();submitForm=false" class="btn gary_btn mr-3" type="filled">Cancel</button>
            <!-- <button v-if="!isCallFromAddEmployee"  color="success" :disabled="submitForm" @click="savebeneficiary" class="btn light_blue_btn" type="filled">Submit</button> -->
            <button v-if="!isCallFromAddEmployee"  color="success" :disabled="submitForm" @click="checkHireDate" class="btn light_blue_btn" type="filled">{{editMode ? 'Update' : 'Submit'}}</button>
            <button v-if="isCallFromAddEmployee"  color="success" :disabled="submitForm" @click="addBenificiary" class="btn light_blue_btn" type="filled">Submit</button>
            
          </div>
      </form>
        </div>
        </modal>
        <vs-popup
          class="holamundo main-popup" :class="{'index-lg': !showEmailChangePopup}"
          :title="showPassword ? 'Current Password' : 'Change Login Email'"
          :active.sync="editEmailPopup"
        >
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full" v-if="!showPassword && !isMfaActivated">
                <!-- disabled="true" -->
                <vs-input :key="'newEmail'"
                  class="w-full"
                  v-validate="'required|email'"
                  v-model="newEmail"
                  label="New Email"
                  name="newEmail"
                  data-vv-as="New Email"
                />
                <span class="text-danger text-sm" v-show="errors.has('newEmail')">{{ errors.first("newEmail")}}</span>
              </div>
              <div class="vx-col w-full" v-if="showPassword && !isMfaActivated">
                <div class="form_group passwod_input">
                  <vs-input :key="'currentPassword'" :type="pwdShow ? 'text' : 'password'" label-placeholder="Current Password" v-validate="'required'" data-vv-as="Current Password" name="currentPassword"
                    v-model="currentPassword" class="w-full no-icon-border custom_pwd" @keyup="formerrors.msg = ''"/>
                  <span class="text-danger text-sm" v-show="errors.has('currentPassword')">{{ errors.first("currentPassword")
                  }}<br /></span>
                  <span class="password-visibility" :class="{'has_val':currentPassword}">
                    <span class="pwd_show_hidef" v-if="!pwdShow" @click="pwdShow = true">
                      <eye-icon  size="1.5x" class="custom-class"></eye-icon>
                    </span>
                    <span  class="pwd_show_hidef"  v-if="pwdShow"  @click="pwdShow = false">
                      <eye-off-icon  size="1.5x" class="custom-class"></eye-off-icon>
                    </span>
                  </span>
                  
                </div>
              </div>
              <template v-if="isMfaActivated && !showPassword">
                <mfaAuthProcess  v-if="isMfaActivated" @mfaCompleted="onMfaCompleted" :mfaDetails="mfaDetails" :fromEditEmp = "true"/>     
              </template>
            </div>
          </div>
          <div class="popup-footer" v-if="!isMfaActivated">
            <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"/></span>
            <vs-button
              color="dark"
              @click="editEmailPopup = false"
              class="cancel"
              type="filled"
            >Cancel</vs-button>
            <vs-button v-if="!showPassword"
              color="success"
              @click="validateEmail"
              :disabled="loading"
              class="save"
              type="filled"
            >Continue</vs-button>
            <vs-button v-if="showPassword"
              color="success"
              @click="validatePassword"
              :disabled="loading"
              class="save"
              type="filled"
            >Validate</vs-button>
          </div>
        </vs-popup>
        <vs-popup class="Change_petition_wrap cls-btn" v-bind:title="'Hire Date'" :active.sync="showHireDateChangePopup">
          <div class="Change_petition">
            <div class="vx-col w-full marb10">
            <p>Updating the Hire Date will recalculate I-9 deadlines and reminders. This may affect the employee’s I-9 completion timelines.</p>
            </div>
          </div>
          <div class="actions_footer">
            <button @click="cancelHireDateChange()" class="btn cancel">Cancel</button>
            <button @click="showHireDateChangePopup = false;savebeneficiary()" class="btn light_blue_btn">Confirm </button>
          </div>
        </vs-popup>
        <vs-popup class="Change_petition_wrap cls-btn index-lg" v-bind:title="'Confirm Email Change'" :active.sync="showEmailChangePopup">
          <div class="Change_petition">
            <div class="vx-col w-full marb10">
            <p>Changing this email updates the user’s login. A verification link will be sent to the new address.</p>
            </div>
          </div>
           <div class="popup-footer" v-if="!isMfaActivated">
            <vs-button
              color="dark"
              @click="showEmailChangePopup= false"
              class="cancel"
              type="filled"
            >Cancel</vs-button>
            <vs-button 
              color="success"
              @click="submitEmailChange()"
              :disabled="loading"
              class="save"
              type="filled"
            >Confirm</vs-button>
          </div>
        </vs-popup>
    </div>
  </template>
  <script>
    import moment from "moment";
    import { InfoIcon } from 'vue-feather-icons'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    import addressFields from "@/views/forms/fields/address.vue";
    // import addressField from "@/views/forms/fields/address.vue";
  import DatepickerField from "@/views/forms/fields/datepicker.vue";
  import { EyeIcon, EyeOffIcon } from "vue-feather-icons";
  import mfaAuthProcess from '../mfaAuthProcess.vue';

    export default {
       props: {
        activeI9CaseId: null,
        petitioner: {
          type: Object,
          default: null
        },
        callFromList:{
          type: Boolean,
          default: false
        },
        isCallFromAddEmployee:{
          type:Boolean,
          default:false
        },
        editMode: {
          default: false,
          type: Boolean
        },
        selectedItem: {
          type: Object,
          default: null
        }
        // value: Object
       },
        components:{
            immiInput,
            immiPhone,
            // addressField,
            addressFields,
            DatepickerField,
            EyeOffIcon,
            EyeIcon,
            InfoIcon,
            mfaAuthProcess
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data(){
          return{
            showHireDateValidationError: false,
            initialHireDate: null,
            showHireDateChangePopup: false,
            showEmailChangePopup: false,
            isMfaActivated: false,
            tempToken: '',
            mfaType:'',
            otpVal:'',
            mfaDetails:null,
            mfaStatus:false,
            remindMeLater:false,
            settingUp : false,
            newEmail: '',
            currentPassword: '',
            pwdShow:false,
            editEmailPopup:false,
            showPassword:false,
            withoutAccount:false,
            debounce:null,
            selectPetitioner:null,
            petitionersList:[],
            formerrors: {
                msg: ""
            },
            countries: [],
            states: [],
            locations: [],
            selectedPetitioner:null,
            submitForm:false,
            sendInviteNow: false,
            newBeneficiaryDetails:{
                  "firstName": "",
                  "middleName": "",
                  "lastName": "",
                  "name": "",
                  "email": "",
                  "phone": "",
                  // "mobileNum": "",
                  "homePhone": "",
                  "phoneCountryCode": {
                      "countryCode": "",
                      "countryCallingCode": ""
                  },
                  "homePhoneCountryCode": {
                      "countryCode": "",
                      "countryCallingCode": ""
                  },
                  "roleId": 51,
              "address": {
                  "line1": "",
                  "line2": "",
                  "aptType": 'APT',
                  "locationId": 0,
                  "stateId": 0,
                  "countryId": null,
                  "zipcode": "",
                  "locationDetails": null,
                  "stateDetails": null,
                  "countryDetails": null,
               },
                  "checkDeleteOrInactive": true
              },
              loading: false
            }
        },
        watch: {
          "newBeneficiaryDetails.email"(newVal) {
            if (!newVal) {
              this.sendInviteNow = false;
            }
          },
          "newBeneficiaryDetails.hiredOn"(newVal){
            this.showHireDateValidationError = false
            if(false && this.editMode && this.activeI9CaseId && this.initialHireDate && newVal && !moment(this.initialHireDate).isSame(newVal, 'days')){
              this.showHireDateChangePopup = true
            }
            if(false && this.editMode && newVal && this.checkProperty(this.newBeneficiaryDetails, 'terminatedOn')){
              let terminationDate = moment(this.checkProperty(this.newBeneficiaryDetails, 'terminatedOn'))
              let hireDate = moment(newVal)
              if(hireDate.isSameOrAfter(terminationDate)){
                this.showHireDateValidationError = true
              } 
            }
          }
        },
        methods:{ 
          getActivationSubtext(userDetails){
            let today = moment(new Date())
            let hireDate = moment(this.initialHireDate)
            let terminationDate = this.checkProperty(userDetails, 'terminatedOn')
            let statusId = this.checkProperty(userDetails, 'statusId')
            if (statusId === 1 && hireDate.isAfter(today)){
              return `Becomes Active on ${moment.utc(hireDate).format('MMM DD, YYYY')}`;
            }else if(statusId === 2 && terminationDate && moment(terminationDate).isAfter(today)){
              return `Terminates on ${moment.utc(terminationDate).format('MMM DD, YYYY')}`;
            }else if(statusId === 4 && this.checkProperty(userDetails, 'statusChangeLogs', 'length') > 0 && this.checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change')){
              return this.checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change')
            }
          },
          getEmployeeStatusColor(statusId) {
            if (statusId == 1) return 'warning';
            if (statusId == 2) return 'success';
            if (statusId == 3) return 'dark';
            if ([4, 5].includes(statusId)) return 'danger';
            return 'primary';
          },  
          onChangeTerminate() {
            this.$emit("openEditTerminate", this.newBeneficiaryDetails);
          },

          cancelHireDateChange(){
            // this.newBeneficiaryDetails.hiredOn = this.initialHireDate
            this.showHireDateChangePopup = false
          },
          changeEmail(){
            this.editEmailPopup = true;
            this.newEmail = '';
            this.showPassword = false;
            this.currentPassword = '';
            this.isMfaActivated = false;
            this.$validator.reset()
          },
          onMfaCompleted(data) {
              if(this.checkProperty(data, 'settingUp') == true){
                this.settingUp= true
                this.mfaType=this.checkProperty(data, 'mfaType')
                this.otpVal = this.checkProperty(data, 'otpVal')
                this.validatePassword();
              } else if (data === 'remindMeLater') {
                this.remindMeLater = true;
                this.validatePassword();
              } else if (data === 'login') {
                this.formmessage = {
                  msg: "",
                };
                this.formerrors = {
                  msg: "",
                };
                this.otpVal=''
                this.tempToken=''
                this. remindMeLater=false,
                this.isMfaActivated = false;
              } else {
                this.otpVal = data;
                this.remindMeLater = false;
                this.validatePassword();
              }
            
            this.mfaStatus = false;
          },
          validateEmail(){
            this.$validator.validateAll().then(result => {
              if(result){
                this.showEmailChangePopup = true
                this.loading = false
              }
            })
          },
          submitEmailChange(){
            let payload = {
              userId: this.selectedItem._id,
              email: this.newEmail,
              editEmail: true,
              "empDetails": {
                  "userId":this.selectedItem._id,
                  "newEmail": this.newEmail,
                  "email": this.selectedItem.email,
                  "name": this.selectedItem.name
              },
            }
            let path = '/users/validate-email'
            this.loading =true;
            this.$store.dispatch("commonAction", {"data":payload ,"path":path})
            .then(response => {
              this.showEmailChangePopup = false
              this.editEmailPopup = false
              this.showToster({message:response.message,isError:false });
              this.loading =false;
              // this.showPassword =true;                      
            }).catch((error)=>{
              //this.showToster({message:error,isError:true });
              this.loading =false;
              this.showEmailChangePopup = false
              this.showToster({message:error,isError:true });
              Object.assign(this.formerrors, {
                  msg:error
                });
            })
          },
          validatePassword(){
            let payload = {
              "editEmail": true,
              "empDetails": {
                  "userId":this.selectedItem._id,
                  "newEmail": this.newEmail,
                  "email": this.selectedItem.email,
                  "name": this.selectedItem.name
              },
              "currentPassword": this.currentPassword
            }
            if(this.settingUp){
              payload['settingUp']=this.settingUp
              payload['code'] = this.otpVal
              payload['mfaType'] = this.mfaType
            }

            if(this.otpVal && this.remindMeLater==false){
              payload["code"] = this.otpVal
            }
            if(this.tempToken){
              payload['sessionToken'] = this.tempToken
            }
            if(this.remindMeLater){
              payload['remindMeLater'] = true
            }
            let path = '/auth/validate-password'
            this.loading =true;
            this.$store.dispatch("commonAction", {"data":payload ,"path":path})
            .then(response => {
              this.showToster({message:response.message,isError:false });
              this.loading =false;
              // console.log(response.data, 'Resssssss')
              if(this.checkProperty(response, 'data')){
                const user = response.data;
                if(user.sessionToken){
                  this.tempToken = user.sessionToken
                }
                if(user.mfa){
                  this.mfaDetails=user
                  this.isMfaActivated = true;
                  this.showPassword = false;
                 
                }
              }else{
                this.isMfaActivated = false;
                this.editEmailPopup = false; 
                this.newEmail='';
                this.showPassword = false;
              }                         
            }).catch((error)=>{
              //this.showToster({message:error,isError:true });
              this.loading =false;
              this.showToster({message:error,isError:true });
              Object.assign(this.formerrors, {
                  msg:error
                });
            })
          },
          setPetDetails(selectedPetitioner=null){
            this.selectedPetitioner =selectedPetitioner
          },
          addNewPet(){
            this.$emit("openAddpetPopUp" );
          },
          searchPet(searchText = ''){
            let self = this;
            clearTimeout(self.debounce)
            self.debounce = setTimeout(() => {
              self.getPetitioners(true, searchText);
            }, 900)
          },
          getPetitioners(callFromSerch=false,searchText='' ) {
      
            let _self =this;
            let query ={
            "matcher":{
              "searchString": searchText,
              "statusIds": [],
              "countryIds": [],
              "stateIds": [],
              "locationIds": [],
              "createdDateRange": []
            },
              "sorting": { 	"path": "createdOn", 	"order": 1 	},
              "page": 1,
              "perpage": 25,
              getMasterData:true
            }
              this.$store.dispatch("getList",{data:query ,path:'/company/list'} ).then(response => {
                  _self.petitionersList = response.list;
              }).catch((err)=>{
                  this.petitionersList =[];
              })
          },
          closeAddBenPopUp(data = null){
            this.$emit('closeAddBenPopUp', data, false)
            this.$modal.hide('createBenRequestModal');
          },
          updatePhoneCountryCode(data, key){
            this.newBeneficiaryDetails[key] = data;  
          },

          addBenificiary(){
            this.$validator.validateAll('beneficiaryform').then(result => {
              if(result){
              let firstname = this.newBeneficiaryDetails['firstName'].trim();
              let lastname = this.newBeneficiaryDetails['lastName'].trim();
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { name: firstname + ' ' + lastname });
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "firstName": firstname });
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "lastName": lastname });
              let obj = {
                    'firstName':this.newBeneficiaryDetails.firstName, 
                    'lastName': this.newBeneficiaryDetails.lastName, 
                    'middleName':this.newBeneficiaryDetails.middleName,
                    'name':`${this.newBeneficiaryDetails.name} (${this.newBeneficiaryDetails.email})`,
                    'namewithoutemail':this.newBeneficiaryDetails.name,
                    'email':this.newBeneficiaryDetails.email,
                    'phone':this.newBeneficiaryDetails.phone,
                    // 'mobileNum': this.newBeneficiaryDetails.mobileNum,
                    'homePhone': this.checkProperty(this.newBeneficiaryDetails,'homePhone'),
                    'phoneCountryCode':this.newBeneficiaryDetails.phoneCountryCode,
                    'homePhoneCountryCode':this.checkProperty(this.newBeneficiaryDetails,'homePhoneCountryCode')
                  }
                  delete obj.phoneCountryCode.itemArrayIndex;      
                  this.showToster({message:'Employee is added successfully',isError:false });           
                  this.$emit('closeAddBenPopUp', obj, true)
                  this.$modal.hide('createBenRequestModal');
              }
            })
          },

          checkHireDate(){ 
            if(this.editMode){
              const hiredOn = this.checkProperty(this.newBeneficiaryDetails, 'hiredOn') ? moment(this.newBeneficiaryDetails.hiredOn).format('YYYY-MM-DD') : null;
              const initialHireDat = this.initialHireDate ? moment(this.initialHireDate).format('YYYY-MM-DD') : null;

              if((hiredOn && initialHireDat && hiredOn != initialHireDat) || (initialHireDat && !hiredOn) ){
                this.showHireDateChangePopup = true
              }else{
                this.savebeneficiary()
              }
            }else{
              this.savebeneficiary()
            }
          },

          savebeneficiary() {
          this.$validator.validateAll('beneficiaryform').then(result => {
            if(result && !this.showHireDateValidationError){
              console.log(" inviteEmployee ", this.newBeneficiaryDetails)
              let firstname = this.newBeneficiaryDetails['firstName'].trim();
              let lastname = this.newBeneficiaryDetails['lastName'].trim();
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { name: firstname + ' ' + lastname });
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "firstName": firstname });
              this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "lastName": lastname });
  
              if(this.selectedPetitioner && this.checkProperty(this.selectedPetitioner, '_id')){
                this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "companyId": this.selectedPetitioner['_id']});
              }
              // else if(this.callFromList && [50].indexOf(this.getUserRoleId)<=-1 && this.checkProperty(this.selectPetitioner, '_id')){
              //   this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "companyId": this.selectPetitioner['_id']});
              // }
              // this.newBeneficiaryDetails = Object.assign(this.newBeneficiaryDetails, { "getOnlyUsersWithAccount": true })
               let postData =this.newBeneficiaryDetails;
               this.submitForm=true
               let path = '/users/register';
               if(this.editMode){
                 path = '/users/update';
                 postData['userId'] = this.selectedItem._id
                 postData['address']['aptType'] = 'APT'
              }else{
                 postData['sendInvite'] = this.sendInviteNow;
               }
              this.$store
                .dispatch("commonAction", {"data":postData ,"path":path})
                .then(response => {
                  let res = response;
  
                  let obj = {
                    '_id':this.checkProperty(response, '_id'),
                    'id':this.checkProperty(response, '_id'),  
                    'name':`${this.checkProperty(response, 'name')} (${this.checkProperty(response, 'email')})`,
                    'namewithoutemail':this.checkProperty(response, 'name'),
                    'email':this.checkProperty(response, 'email'),
                    'phone':this.checkProperty(response, 'phone'),
                    // 'mobileNum':this.checkProperty(response, 'mobileNum'),
                    'homePhone':this.checkProperty(response, 'homePhone'),
                    'phoneCountryCode':this.checkProperty(response, 'phoneCountryCode'),
                    'homePhoneCountryCode':this.checkProperty(response, 'homePhoneCountryCode'),
                    'selectedPetitioner':this.selectedPetitioner
                  }
                   this.showToster({message:response.message,isError:false });
                  this.submitForm =false;
                 this.closeAddBenPopUp(obj)
                 this.$modal.hide('createBenRequestModal');
                })
                .catch((error)=>{
                  this.submitForm =false;
                  this.showToster({message:error,isError:true });
                  Object.assign(this.formerrors, {
                      msg:error
                    });
                })
            }
          });
        },
        changedCountry() {
          this.states = [];
          this.locations = [];
          this.newBeneficiaryDetails.address.locationDetails = null;
          let dataKey = "newBeneficiaryDetails";

          if (_.has(this[dataKey].address.countryDetails, "id")) {
            this[dataKey].address.countryId =
              this[dataKey].address.countryDetails["id"];

            this.masterData("states");
          }
          // this.newBeneficiaryDetails.address.zipcode = '';
        },
        changedState() {
          this.$validator.validate('beneficiaryform.State')
          let dataKey = "newBeneficiaryDetails";

          this.locations = [];
          if (_.has(this[dataKey].address.stateDetails, "id")) {
            this[dataKey].address.stateId =
              this[dataKey].address.stateDetails["id"];
            this.masterData("locations");
          }
        },
        //locationId
        changedCity() {
          this.$validator.validate('beneficiaryform.city')
          let dataKey = "newBeneficiaryDetails";

          if (_.has(this[dataKey].address.locationDetails, "id")) {
            this[dataKey].address.locationId =
              this[dataKey].address.locationDetails["id"];
            this.masterData("locations");
          }
        },
        masterData(category = "countries") {
          let matcher = {};
          let postData = {
            matcher: matcher,
            page: 1,
            perpage: 1000,
            category: category,
          };

          let dataKey = "newBeneficiaryDetails";
          if (category == "states") {
            matcher = { countryId: this.checkProperty(this[dataKey], "address","countryDetails")?this[dataKey].address.countryDetails["id"]:"" };
          }
          if (category == "locations") {
            matcher = { stateId: this[dataKey].address.stateDetails["id"] };
          }
          postData["matcher"] = matcher;
          this.loading = true;
          this.$store
            .dispatch("getMasterData", postData)
            .then((res) => {
              //countries
              if (category == "countries") {
                this.countries = res["list"];
                this.newBeneficiaryDetails["address"]["countryDetails"] = _.find(this.countries, { "id": 231 })

                //alert(JSON.stringify(this.countries))
              }
              if (category == "states") {
                this.states = res["list"];
                this[dataKey]["address"].stateDetails = _.find(this.states, {
                  id: this[dataKey]["address"]["stateId"],
                });
                this.changedState();
              }
              if (category == "locations") {
                this.locations = res["list"];
                this[dataKey]["address"].locationDetails = _.find(this.locations, {
                  id: this[dataKey]["address"]["locationId"],
                });
              }
              this.loading = false;
            })
            .catch((err) => {
              this[category] = [];
              this.loading = false;
            });
        },
        checkZipCodeFormat(){
        
            if( this.newBeneficiaryDetails.address.countryDetails && this.newBeneficiaryDetails.address.zipcode ){
                if(this.checkProperty(this.newBeneficiaryDetails.address.countryDetails ,'allowNumAndCharInZipcode')==true){
                  this.newBeneficiaryDetails.address.zipcode = this.newBeneficiaryDetails.address.zipcode.replace(/[^a-z A-Z 0-9]/g, '').replace(/(\..*)\./g, '$1');
                }else{
                  this.newBeneficiaryDetails.address.zipcode = this.newBeneficiaryDetails.address.zipcode.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
                }
            }
          },
        },
        mounted(){
          if([48,50,12].indexOf(this.getUserRoleId)<=-1){
            this.getPetitioners();
          }
          
          this.$store.dispatch("getcountries").then((response) => {
                  this.countries = response;
              });
            this.$modal.show('createBenRequestModal');
            if(this.petitioner){
              this.selectedPetitioner = this.petitioner
            }
            if(this.editMode && this.selectedItem){

              this.newBeneficiaryDetails = this.selectedItem
              this.initialHireDate = this.checkProperty(this.selectedItem, 'hiredOn')

              if(!this.addressExists(this.checkProperty(this.selectedItem, 'address'))){
                this.newBeneficiaryDetails['address']['countryId'] = 231
                this.newBeneficiaryDetails['address']['countryDetails'] = {
                                                        _id: "61408c9ed01ea1248cdcf6b7",
                                                        id: 231,
                                                        name: "United States",
                                                        phoneCode: 1,
                                                        order: 1,
                                                        currencySymbol: "$",
                                                        currencyCode: "USD",
                                                        zipcodeLength: 5,
                                                        sortName: "united states",
                                                      };
                this.changedCountry()
              }else{
                 if (_.has(this.newBeneficiaryDetails, "address", "countryDetails") && this.checkProperty(this.newBeneficiaryDetails,'address','countryDetails')){
                          this.newBeneficiaryDetails["address"]["countryDetails"] = this.newBeneficiaryDetails["address"]["countryDetails"];
                          let countryDetails = this.newBeneficiaryDetails["address"]["countryDetails"];
                          if(this.checkProperty(countryDetails, 'id')){
                            this.masterData("states");
                          }
                  }else{
                    this.newBeneficiaryDetails["address"]["countryId"] = 231
                    this.masterData("states"); 
                  }
                  if (_.has(this.newBeneficiaryDetails, "address", "stateDetails"))
                    this.newBeneficiaryDetails["address"]["stateDetails"] = this.newBeneficiaryDetails["address"]["stateDetails"];

                  if (_.has(this.newBeneficiaryDetails, "address", "locationDetails"))
                    this.newBeneficiaryDetails["address"]["locationDetails"] = this.newBeneficiaryDetails["address"]["locationDetails"];
              }
              // console.log(" newBeneficiaryDetails    ",this.newBeneficiaryDetails);
            }
        },
       
    }
  
  
  </script>
   <style scoped>

    .header-left {
      display: flex;
      align-items: flex-start;
      gap: 4px;
    }
  
  </style>